import '../../css/mk-brand.css';
import React, {useEffect} from "react";

function Panel() {
  useEffect(() => {}, );
  return (
      <div id="ready-set-whip" className="m-2">
        <div className="container bg-zinc-800 pt-4 px-4 md:px-32 pb-4 rounded-lg max-w-4xl">
          <div className="flex flex-row">
            <div className="max-w-2xl mx-auto mb-10">
              <div className="flex-row">
                <div>
                  <div className="flex">
                    <span className="mx-auto text-5xl md:text-6xl lg:text-5xl font-bold text-brand">
                      Ready, <span className="text-brand-text">Set, </span>Whip!
                    </span>
                  </div>
                  <div className="text-brand-text text-2xl text-right cursor-pointer hover:font-bold">
                    <a href="https://metakitchen.gitbook.io/metakitchen-wp/wb1pN4vYLKsa8w4IX5qL/the-menu/game-mechanics/ready-set-whip">
                      mini-game
                    </a>
                  </div>
                  <div className="border border-brand" />
                </div>
              </div>
              <p className="mb-6 mt-6 text-white md:text-2xl">
                As we release the core collections required for the full <span className="text-brand font-extrabold">mK</span><b>Battle</b> game: Ingredients and Utensils; these new NFTs will be integrated into the <span className="text-2xl md:text-3xl lg:text-2xl font-bold text-brand">Super<span className="text-brand-text">OG </span></span> battles.
              </p>
              <ul className="list-disc ml-6 md:text-2xl">
                <li><b>Power Up Challenges:</b> Enhance OG Chefs with power ups from Ingredients and Utensils.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
  );
}

export default Panel;